import { cn } from "helpers/classNames";
import { FC } from "react";
import { Link as RRLink, LinkProps } from "@tanstack/react-router";

type CustomProps = {
  isLinkButton?: boolean;
  variant?: "primary" | "secondary" | "gray";
  className?: string;
};

export const Link: FC<
  LinkProps & CustomProps & React.RefAttributes<HTMLAnchorElement>
> = ({
  children,
  isLinkButton = false,
  className,
  variant = "secondary",
  ...rest
}) => (
  <RRLink
    className={cn(
      "font-medium",
      variant === "secondary" && "text-pink-600 hover:text-pink-800",
      variant === "primary" && "text-cyan-600 hover:text-cyan-800",
      variant === "gray" && "text-gray-800 underline hover:text-gray-950",
      // Link buttons are always gray — placed last so they win over the variant color
      isLinkButton &&
        "rounded-md bg-white px-2.5 py-1.5 text-sm font-medium text-gray-900 no-underline shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 hover:text-gray-900 sm:text-xs",
      className,
    )}
    {...rest}
  >
    {children}
  </RRLink>
);
